import { Grid } from '@fortune-ui'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { type WordPressMobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const WORDPRESS_MOBILE: WordPressMobileMediaQuery = '@media (max-width: 960px)'

interface OrderLabelProps<T> {
  label: string
  value: T
  bold?: boolean
  children?: ReactNode
  childrenBelow?: boolean
}

const styles = stylex.create({
  label: {
    flexShrink: 0,
    minWidth: {
      [WORDPRESS_MOBILE]: '70px',
      default: 'auto',
    },
  },
})

export function OrderLabel<T extends ReactNode>({ label, value, bold, children, childrenBelow }: OrderLabelProps<T>) {
  const isWordPressTablet = useResponsive('wordPressTablet')
  return (
    <Grid container item xs={12} md={6} lg={4}>
      <HStack columnGap={isWordPressTablet ? 2 : 4}>
        <Text color={colors.grey600} rootStyle={styles.label} noWrap>{label}</Text>
        {childrenBelow
          ? (
            <VStack>
              <Text component="span" bold={bold} color={colors.grey800}>{value}</Text>
              {children}
            </VStack>
          )
          : (
            <HStack gap={2}>
              <Text component="span" bold={bold} color={colors.grey800}>{value}</Text>
              {children}
            </HStack>
          )}
      </HStack>
    </Grid>
  )
}
